import { makeAutoObservable } from "mobx"
import Content from "store/content"
import { JsonSchema } from "store/json-schema"

class ContentBlock {

  value: string = ""
  block: JsonSchema['blocks'][0]
  blockId: string
  children: ContentBlock[][] = []
  enabled = true

  constructor(id: string, block: JsonSchema['blocks'][0]) {
    this.blockId = id
    this.block = block
    for (let i = 0; i < block.emitters.length; i++) {
      this.children.push([])
    }
    makeAutoObservable(this)
  }

  findChildren(blockId: string, schema: JsonSchema, content: Content) {
    if (content.ignoreBlocks?.includes(blockId)) {
      this.enabled = false
    }
    for (let chain of schema.chains) {
      if (chain.from[0] === blockId) {
        const block = schema.blocks[chain.to]
        const contentBlock = new ContentBlock(chain.to, block)
        contentBlock.findChildren(chain.to, schema, content)
        this.children[chain.from[1]].push(contentBlock)
      }
    }
  }

  sort(callback: (a: ContentBlock, b: ContentBlock) => number) {
    for (let child of this.children) {
      child.sort(callback)
      for (let ch of child) {
        ch.sort(callback)
      }
    }
  }

  setValue(value: string) {
    this.value = value
  }

}

export default ContentBlock